import {
    REMOVE_GUEST_USER,
} from './types'

export const removeGuestReducer = () => dispatch => {
    dispatch({
        type: REMOVE_GUEST_USER
    })
}
